const getFilterNestedField = (compositeString) => {
  const startBracketIndex = compositeString.indexOf("[");
  const endBracketIndex = compositeString.lastIndexOf("]");
  const field = compositeString.substring(startBracketIndex + 1, endBracketIndex);
  const [fieldKey, fieldValue = ""] = field.split("=");
  try {
    return {
      key: fieldKey,
      value: JSON.parse(fieldValue)
    };
  } catch {
  }
};
export {
  getFilterNestedField
};
